'use strict';

module.exports = function (ngModule) {
    // system config
    ngModule.config(require('./system'));
    // remove the /#! from urls
    ngModule.config(require('./html5urls'));
}


/** WEBPACK FOOTER **
 ** ./src/system/routes/index.js
 **/